<template>
  <Download class="download-page" />
</template>

<script>
import Download from "@/components/Download.vue";

export default {
  components: {
    Download
  }
};
</script>
